import { CartConfigInterface } from "../../CartTypes";

export const CartColors = [
    {
        hex: "#3801ca", // Purple
        hue: 256,
        saturation: 0.9901477832512315,
        brightness: 0.3980392156862745,
        alpha: 1,
    },
    {
        hex: "#0E78DE", // Blue
        hue: 209,
        saturation: 0.8813559322033898,
        brightness: 0.4627450980392157,
        alpha: 1,
    },
    {
        hex: "#42B8FA", // SkyBlue
        hue: 202,
        saturation: 0.9484536082474225,
        brightness: 0.6196078431372549,
        alpha: 1,
    },
    {
        hex: "#018A06", // Green
        hue: 122,
        saturation: 0.985611510791367,
        brightness: 0.2725490196078431,
        alpha: 1,
    },
    {
        hex: "#FFE003", // Yellow
        hue: 53,
        saturation: 1,
        brightness: 0.5058823529411764,
        alpha: 1,
    },
    {
        hex: "#ED6B04", // Orange
        hue: 27,
        saturation: 0.9668049792531122,
        brightness: 0.4725490196078431,
        alpha: 1,
    },

    {
        hex: "#D82726", // Red
        hue: 0,
        saturation: 0.7007874015748031,
        brightness: 0.4980392156862745,
        alpha: 1,
    },
    {
        hex: "#711814", // DarkBrown
        hue: 3,
        saturation: 0.6992481203007519,
        brightness: 0.26078431372549016,
        alpha: 1,
    },
    {
        hex: "#D9A985", // SkinColor
        hue: 26,
        saturation: 0.5249999999999999,
        brightness: 0.6862745098039216,
        alpha: 1,
    },
    {
        hex: "#000000", //Black
        hue: 0,
        saturation: 0,
        brightness: 0,
        alpha: 1,
    },
];

export const updateAllFields = (fields: any, updatedConfig: CartConfigInterface) => {
    const {
        cart_design: {
            cart_bg_color,
            cart_font_family,
            cart_width,
            cart_primary_color,
            cart_lighten_primary_color,
            cart_gradient_color,

            // Header
            header_bg_color,
            header_title_color,
            header_title_underline_color,
            header_title_underline_color_gradient_status,
            header_title_underline_color_gradient_direction,
            header_title_underline_color_gradient_color,
            header_quantity_color,
            header_height,
            close_button_color,

            // CartLine Card
            cartline_card_bg_color,
            cartline_card_text_color,
            cartline_card_save_text_color,
            cartline_card_qty_color,
            cartline_card_discount_bg_color,
            cartline_card_discount_text_color,
            cartline_card_title_size,
            cartline_card_title_style,
            cartline_card_properties_size,
            cartline_card_properties_style,
            cartline_card_price_size,
            cartline_card_price_style,
            cartline_card_compared_price_size,
            cartline_card_compared_price_style,
            cartline_card_save_text_size,
            cartline_card_save_text_style,

            // Footer
            footer_text_color,
            footer_compare_at_color,
            footer_secondary_text_color,
            footer_bg_color,
            footer_button_radius,
            footer_button_bg_color,
            footer_button_text_color,
            footer_button_border_color,
            footer_button_hover_border_color,
            footer_button_bg_hover_color,
            footer_button_text_hover_color,
        },
        reward_design: {
            bar_background_color,
            bar_foreground_color,
            bar_foreground_gradient_status,
            bar_foreground_gradient_direction,
            bar_foreground_gradient_color,
            free_gift_bg_color,
            free_gift_button_bg_color,
            free_gift_button_text_color,
            reward_free_gift_text_color,
            reward_free_gift_product_title_color,
            free_gift_free_label_color,
        },

        upsell_design: {
            upsell_bg_color,
            upsell_title_color,
            upsell_product_bg_color,
            upsell_product_border_color,
            upsell_product_text_color,
            upsell_product_title_size,
            upsell_product_title_style,
            upsell_product_discount_text_color,
            upsell_button_radius,
            upsell_card_radius,
            upsell_title_size,
            upsell_price_size,
            upsell_price_style,
            upsell_compared_price_size,
            upsell_compared_price_style,
            upsell_discount_size,
            upsell_discount_style,
            upsell_button_bg_color,
            upsell_button_text_color,
            upsell_button_border_color,
            upsell_button_hover_border_color,
            swatches_select_color,
            upsell_button_bg_hover_color,
            upsell_button_text_hover_color,
        },
        announcement_design: {
            message_text_color,
            message_bg_color,
            countdown_timer_color,
            message_text_size,
            message_text_style,
            countdown_timer_size,
        },
        discount: _discount,
        discount_design: _discount_design,
        additional_note_design: _additional_note_design,
        additional_product_design: {
            additional_product_card_bg,
            additional_product_title_color,
            additional_product_description_color,
            additional_product_border_color,
            additional_product_border_gradient_status,
            additional_product_border_gradient_direction,
            additional_product_border_gradient_color,
            additional_product_title_size,
            additional_product_description_size,
            additional_product_description_style,
            addon_modal_title_size,
            addon_modal_background_color,
            addon_modal_title_color,
            addon_modal_primary_button_bg,
            addon_modal_primary_button_text_color,
            addon_modal_secondary_button_text_color,
        },
        additional_message: {
            additional_msg_text,
            additional_msg_bg,
            additional_msg_color,
            additional_msg_text_size,
            additional_msg_text_style,
        },
    } = fields;
    const {
        cart_design,
        reward_design,
        upsell_design,
        announcement_design,
        discount,
        discount_design,
        additional_note_design,
        additional_product_design,
        additional_message,
    } = updatedConfig;

    // Cart Design
    cart_primary_color.onChange(cart_design.cart_primary_color);
    cart_lighten_primary_color.onChange(cart_design.cart_lighten_primary_color);
    cart_gradient_color.onChange(cart_design.cart_gradient_color);
    cart_bg_color.onChange(cart_design?.cart_bg_color);
    cart_font_family.onChange(cart_design?.cart_font_family);
    cart_width.onChange(cart_design?.cart_width);
    header_bg_color.onChange(cart_design?.header_bg_color);
    header_title_color.onChange(cart_design?.header_title_color);
    header_title_underline_color.onChange(cart_design?.header_title_underline_color);
    header_title_underline_color_gradient_status.onChange(cart_design?.header_title_underline_color_gradient_status);
    header_title_underline_color_gradient_direction.onChange(
        cart_design?.header_title_underline_color_gradient_direction,
    );
    header_title_underline_color_gradient_color.onChange(cart_design?.header_title_underline_color_gradient_color);
    header_quantity_color.onChange(cart_design?.header_quantity_color);
    header_height.onChange(cart_design?.header_height);
    close_button_color.onChange(cart_design?.close_button_color);
    cartline_card_bg_color.onChange(cart_design?.cartline_card_bg_color);
    cartline_card_text_color.onChange(cart_design?.cartline_card_text_color);
    cartline_card_save_text_color.onChange(cart_design?.cartline_card_save_text_color);
    cartline_card_qty_color.onChange(cart_design?.cartline_card_qty_color);
    cartline_card_discount_bg_color.onChange(cart_design?.cartline_card_discount_bg_color);
    cartline_card_discount_text_color.onChange(cart_design?.cartline_card_discount_text_color);
    cartline_card_title_size.onChange(cart_design?.cartline_card_title_size);
    cartline_card_title_style.onChange(cart_design?.cartline_card_title_style);
    cartline_card_properties_size.onChange(cart_design?.cartline_card_properties_size);
    cartline_card_properties_style.onChange(cart_design?.cartline_card_properties_style);
    cartline_card_price_size.onChange(cart_design?.cartline_card_price_size);
    cartline_card_price_style.onChange(cart_design?.cartline_card_price_style);
    cartline_card_compared_price_size.onChange(cart_design?.cartline_card_compared_price_size);
    cartline_card_compared_price_style.onChange(cart_design?.cartline_card_compared_price_style);
    cartline_card_save_text_size.onChange(cart_design?.cartline_card_save_text_size);
    cartline_card_save_text_style.onChange(cart_design?.cartline_card_save_text_style);
    footer_text_color.onChange(cart_design?.footer_text_color);
    footer_compare_at_color.onChange(cart_design?.footer_compare_at_color);
    footer_secondary_text_color.onChange(cart_design?.footer_secondary_text_color);
    footer_bg_color.onChange(cart_design?.footer_bg_color);
    footer_button_radius.onChange(cart_design?.footer_button_radius);
    footer_button_bg_color.onChange(cart_design?.footer_button_bg_color);
    footer_button_text_color.onChange(cart_design?.footer_button_text_color);
    footer_button_border_color.onChange(cart_design?.footer_button_border_color);
    footer_button_hover_border_color.onChange(cart_design?.footer_button_hover_border_color);
    footer_button_bg_hover_color.onChange(cart_design?.footer_button_bg_hover_color);
    footer_button_text_hover_color.onChange(cart_design?.footer_button_text_hover_color);

    // Reward Design
    bar_background_color.onChange(reward_design?.bar_background_color);
    bar_foreground_color.onChange(reward_design?.bar_foreground_color);
    bar_foreground_gradient_status.onChange(reward_design.bar_foreground_gradient_status);
    bar_foreground_gradient_direction.onChange(reward_design.bar_foreground_gradient_direction);
    bar_foreground_gradient_color.onChange(reward_design.bar_foreground_gradient_color);
    free_gift_bg_color.onChange(reward_design.free_gift_bg_color);
    free_gift_button_bg_color.onChange(reward_design.free_gift_button_bg_color);
    free_gift_button_text_color.onChange(reward_design.free_gift_button_text_color);
    reward_free_gift_text_color.onChange(reward_design.reward_free_gift_text_color);
    reward_free_gift_product_title_color.onChange(reward_design.reward_free_gift_product_title_color);
    free_gift_free_label_color.onChange(reward_design.free_gift_free_label_color);

    // Upsell Design
    upsell_bg_color.onChange(upsell_design?.upsell_bg_color);
    upsell_title_color.onChange(upsell_design?.upsell_title_color);
    upsell_product_bg_color.onChange(upsell_design?.upsell_product_bg_color);
    upsell_product_border_color.onChange(upsell_design?.upsell_product_border_color);
    upsell_product_text_color.onChange(upsell_design?.upsell_product_text_color);
    upsell_product_title_size.onChange(upsell_design?.upsell_product_title_size);
    upsell_product_title_style.onChange(upsell_design?.upsell_product_title_style);
    upsell_product_discount_text_color.onChange(upsell_design?.upsell_product_discount_text_color);
    upsell_button_radius.onChange(upsell_design?.upsell_button_radius);
    upsell_card_radius.onChange(upsell_design?.upsell_card_radius);
    upsell_title_size.onChange(upsell_design?.upsell_title_size);
    upsell_price_size.onChange(upsell_design?.upsell_price_size);
    upsell_price_style.onChange(upsell_design?.upsell_price_style);
    upsell_compared_price_size.onChange(upsell_design?.upsell_compared_price_size);
    upsell_compared_price_style.onChange(upsell_design?.upsell_compared_price_style);
    upsell_discount_size.onChange(upsell_design?.upsell_discount_size);
    upsell_discount_style.onChange(upsell_design?.upsell_discount_style);
    upsell_button_bg_color.onChange(upsell_design?.upsell_button_bg_color);
    upsell_button_text_color.onChange(upsell_design?.upsell_button_text_color);
    upsell_button_border_color.onChange(upsell_design?.upsell_button_border_color);
    upsell_button_hover_border_color.onChange(upsell_design?.upsell_button_hover_border_color);
    swatches_select_color.onChange(upsell_design?.swatches_select_color);
    upsell_button_bg_hover_color.onChange(upsell_design?.upsell_button_bg_hover_color);
    upsell_button_text_hover_color.onChange(upsell_design?.upsell_button_text_hover_color);

    // Announcement Design
    message_text_color.onChange(announcement_design?.message_text_color);
    message_bg_color.onChange(announcement_design?.message_bg_color);
    countdown_timer_color.onChange(announcement_design?.countdown_timer_color);
    message_text_size.onChange(announcement_design?.message_text_size);
    message_text_style.onChange(announcement_design?.message_text_style);
    countdown_timer_size.onChange(announcement_design?.countdown_timer_size);

    // Discount
    _discount.title.onChange(discount.title);
    _discount.placeholder.onChange(discount.placeholder);
    _discount.cta_text.onChange(discount.cta_text);

    // Discount Design
    _discount_design.title_color.onChange(discount_design?.title_color);
    _discount_design.icon_color.onChange(discount_design?.icon_color);
    _discount_design.cta_bg_color.onChange(discount_design?.cta_bg_color);
    _discount_design.cta_bg_hover_color.onChange(discount_design?.cta_bg_hover_color);
    _discount_design.cta_text_color.onChange(discount_design?.cta_text_color);
    _discount_design.cta_text_hover_color.onChange(discount_design?.cta_text_hover_color);
    _discount_design.code_bg_color.onChange(discount_design?.code_bg_color);
    _discount_design.code_text_color.onChange(discount_design?.code_text_color);

    // Additional Note Design

    _additional_note_design.title_color.onChange(additional_note_design?.title_color);
    _additional_note_design.icon_color.onChange(additional_note_design?.icon_color);
    _additional_note_design.cta_bg_color.onChange(additional_note_design?.cta_bg_color);
    _additional_note_design.cta_bg_hover_color.onChange(additional_note_design?.cta_bg_hover_color);
    _additional_note_design.cta_text_color.onChange(additional_note_design?.cta_text_color);
    _additional_note_design.cta_text_hover_color.onChange(additional_note_design?.cta_text_hover_color);

    // Additional Product Design
    additional_product_card_bg.onChange(additional_product_design?.additional_product_card_bg);
    additional_product_title_color.onChange(additional_product_design?.additional_product_title_color);
    additional_product_description_color.onChange(additional_product_design?.additional_product_description_color);
    additional_product_border_color.onChange(additional_product_design?.additional_product_border_color);
    additional_product_border_gradient_status.onChange(
        additional_product_design?.additional_product_border_gradient_status,
    );
    additional_product_border_gradient_direction.onChange(
        additional_product_design?.additional_product_border_gradient_direction,
    );
    additional_product_border_gradient_color.onChange(
        additional_product_design?.additional_product_border_gradient_color,
    );
    additional_product_title_size.onChange(additional_product_design?.additional_product_title_size);
    additional_product_description_size.onChange(additional_product_design?.additional_product_description_size);
    additional_product_description_style.onChange(additional_product_design?.additional_product_description_style);

    // Addon Modal Design
    addon_modal_title_size.onChange(additional_product_design?.addon_modal_title_size);
    addon_modal_background_color.onChange(additional_product_design?.addon_modal_background_color);
    addon_modal_title_color.onChange(additional_product_design?.addon_modal_title_color);
    addon_modal_primary_button_bg.onChange(additional_product_design?.addon_modal_primary_button_bg);
    addon_modal_primary_button_text_color.onChange(additional_product_design?.addon_modal_primary_button_text_color);
    addon_modal_secondary_button_text_color.onChange(
        additional_product_design?.addon_modal_secondary_button_text_color,
    );

    // Additional Message
    additional_msg_text.onChange(additional_message?.additional_msg_text);
    additional_msg_bg.onChange(additional_message?.additional_msg_bg);
    additional_msg_color.onChange(additional_message?.additional_msg_color);
    additional_msg_text_size.onChange(additional_message?.additional_msg_text_size);
    additional_msg_text_style.onChange(additional_message?.additional_msg_text_style);
};
